// extracted by mini-css-extract-plugin
export default {"500":"(min-width: 500px)","800":"(min-width: 800px)","1200":"(min-width: 1200px)","root":"LKeeh_nnxgcZBon049hb","wrap":"BgIHehU1cqZN0gM8M3Fc","header":"fWOhLdfaRaQBNo6XxUKQ"};